import { css, CSSResult } from 'lit'

export const style: CSSResult = css`
  :host {
    display: contents;
  }
`
